export default __webpack_public_path__ + "static/media/jose.363a2c5e.jpg";